import type { CelebrityResult } from "./types";

export const mikeBibby: CelebrityResult = {
  slug: "mike-bibby",
  firstName: "Mike",
  lastName: "Bibby",
  roleLines: ["Professional Basketball Player (Retired)", "2,998 Grafts"],
  headlineLines: ["Slam Dunk Results for This Former Pro Basketball Player"],
  intro: [
    "For years, Mike Bibby was a force to be reckoned with on the basketball court. But over time, he began to notice that his hair was starting to fade away. Wanting to get back his youthful appearance, he made the decision to call RESTORE®.",
  ],
  heroBannerImage: {
    src: "/endorser-banners/bibby_website_banner_1920x800_v1.webp",
    alt: "Mike Bibby RESTORE hair restoration results banner",
  },
  heroBannerImageMobile: {
    src: "/endorser-banners/bibby_website_mobile_800x879_v1.webp",
    alt: "Mike Bibby RESTORE hair restoration results banner",
  },
  heroBackground:
    "/img/r/wp-2024-09-mike-bibby-feature-nologos-gigapixel-hq-width-2000px.webp",
  heroLayout: "diagonal-right",
  heroMinHeight: "700px",
  posterImage: {
    src: "/img/r/wp-2024-09-mike-bibby-poster.webp",
    alt: "Mike Bibby holding a basketball after his RESTORE hair transplant",
  },
  heroBeforeAfter: {
    src: "/img/r/wp-2024-09-mike-bibby-before-after.webp",
    alt: "Mike Bibby before and after hair transplant",
  },
  story: {
    headingSuffix: "Hair Transplant Journey",
    paragraphs: [
      "For years, guard Mike Bibby was a force to be reckoned with on the basketball court, especially during his time with the Sacramento Kings. As a standout player, Bibby was known for his skill, leadership, and fierce competitiveness. However, fans noticed that over time, player Mike Bibby\u2019s look started to change as his hair began to fade away\u2014a common experience for many athletes constantly in the spotlight. Recently, in a CBS interview, he shared that he had become more self-conscious about his appearance since those days. This transformation has inspired others to keep up with how he maintains his iconic look, from his days on the court to his current haircut choices, despite leaving the NBA years ago.",
      "Mike Bibby regularly shares on social media more about basketball mikescuts, and viral mikescuts.",
      "Wanting to reclaim his youthful appearance, Mike Bibby decided it was time to take action and contacted RESTORE® to start his journey toward a fuller head of hair. The transformation gave him a boost in confidence and a renewed sense of self, helping him feel as vibrant off the court as he once was on it. Bibby shares that his friends, former teammates, and even fans have noticed the change and often ask how he managed such a natural-looking restoration. He\u2019s always proud to point them in the direction of RESTORE, crediting the team for not only achieving the results he wanted but also providing an experience that left him feeling supported and informed every step of the way.",
    ],
  },
  gallery: {
    images: [
      {
        src: "/img/r/wp-2021-12-mike-b-small-1-1-232x300.webp",
        alt: "Mike Bibby Hair Transplant",
      },
      {
        src: "/img/r/wp-2021-12-mike-b-medium-1-1-300x275.webp",
        alt: "Mike Bibby Hair Transplant",
      },
      {
        src: "/img/r/wp-2021-12-mike-b-large-2-1-300x190.webp",
        alt: "Mike Bibby Hair Transplant",
      },
      {
        src: "/img/r/wp-2021-12-mike-b-large-1-1-300x190.webp",
        alt: "Mike Bibby Hair Transplant",
      },
    ],
  },
  seoH1: "NBA Player Mike Bibby Hair Transplant Journey",
  seo: {
    title: "Mike Bibby Hair Transplant Results | RESTORE Hair",
    description:
      "Learn why Mike Bibby came to RESTORE. See behind the scenes photos and hear his story on how RESTORE has helped him.",
  },
};
